import React from 'react';
import {
  HamburgerIcon,
  EjectTipIcon,
  ConfigApparatusIcon as AdjustVolumeIcon,
} from '../../../Icons';

export function useMicroPipetteTooltip(props) {
  function getButtonList(props) {
    let buttonList = [];

    buttonList.push(
      {
        onClick: () => {},
        image: HamburgerIcon,
      },
      {
        onClick: props.openVolumeModal,
        label: props.volume + ' uL',
      }
    );

    if (props.onRemoveTip) {
      buttonList.push({
        onClick: props.onRemoveTip,
        image: EjectTipIcon,
      });
    }

    return buttonList;
  }

  return {getButtonList};
}
